module.exports = __webpack_public_path__ + "static/media/katie-bse2.37b74074.jpg";